// eslint-disable-next-line no-unused-vars
import React from 'react'
import { connect } from 'react-redux'
import { actions } from './'
import Cellphonerecharge from './Cellphonerecharge'

const mapStateToProps = ({
  cellphoneRecharge: {
    loadingFinalizeOrder,
    loadingScheduleOrder,
    errorMessage
  }
}) => {
  return {
    errorMessage,
    loadingFinalizeOrder,
    loadingScheduleOrder
  }
}

const mapDispatchToProps = dispatch => ({
  insertMobileRecharge: (serviceId, operatorKey, areaCode, phone) => {
    dispatch(
      actions.insertMobileRecharge(serviceId, operatorKey, areaCode, phone)
    )
  },
  scheduleMobileRecharges: (
    serviceId,
    operatorKey,
    areaCode,
    phone,
    initialScheduleDate,
    endScheduleDate,
    creditValue,
    pointValue
  ) =>
    dispatch(
      actions.scheduleMobileRecharges(
        serviceId,
        operatorKey,
        areaCode,
        phone,
        initialScheduleDate,
        endScheduleDate,
        creditValue,
        pointValue
      )
    ),
  clearErrorMessage: () => dispatch({ type: 'CLEAR_ERROR_MESSAGE' })
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cellphonerecharge)



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/CellphonerechargeContainer.js